import { useEffect } from "react";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

// Fullscreen zoom & pan viewer for admiring the surface texture of a
// painting. Mouse-wheel / pinch zooms, click-drag pans, double-click resets.
// If onPrev / onNext handlers are provided, arrow buttons + keyboard arrows
// walk through a set of images (main + room shots).
export default function Lightbox({ src, alt, open, onClose, onPrev, onNext, counter }) {
  useEffect(() => {
    if (!open) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowRight" && onNext) onNext();
      if (e.key === "ArrowLeft" && onPrev) onPrev();
    };
    document.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = prev;
      document.removeEventListener("keydown", onKey);
    };
  }, [open, onClose, onPrev, onNext]);

  if (!open) return null;

  return (
    <div className="lightbox" role="dialog" aria-modal="true" data-testid="lightbox">
      <button
        type="button"
        className="lightbox__scrim"
        onClick={onClose}
        aria-label="Close viewer"
        data-testid="lightbox-close"
      />
      <TransformWrapper
        initialScale={1}
        minScale={1}
        maxScale={6}
        doubleClick={{ mode: "reset" }}
        wheel={{ step: 0.15 }}
        pinch={{ step: 5 }}
      >
        {({ zoomIn, zoomOut, resetTransform }) => (
          <>
            <TransformComponent wrapperClass="lightbox__stage" contentClass="lightbox__content">
              <img src={src} alt={alt || ""} draggable="false" data-testid="lightbox-image" />
            </TransformComponent>

            {onPrev && (
              <button
                type="button"
                className="lightbox__nav lightbox__nav--prev"
                onClick={(e) => { e.stopPropagation(); onPrev(); }}
                aria-label="Previous image"
                data-testid="lightbox-prev"
              >&larr;</button>
            )}
            {onNext && (
              <button
                type="button"
                className="lightbox__nav lightbox__nav--next"
                onClick={(e) => { e.stopPropagation(); onNext(); }}
                aria-label="Next image"
                data-testid="lightbox-next"
              >&rarr;</button>
            )}

            <div className="lightbox__controls mono-caps" data-testid="lightbox-controls">
              <button type="button" onClick={() => zoomOut()} aria-label="Zoom out" data-testid="lightbox-zoom-out">−</button>
              <button type="button" onClick={() => resetTransform()} aria-label="Reset zoom" data-testid="lightbox-zoom-reset">Reset</button>
              <button type="button" onClick={() => zoomIn()} aria-label="Zoom in" data-testid="lightbox-zoom-in">+</button>
              {counter && <span className="lightbox__counter" data-testid="lightbox-counter">{counter}</span>}
            </div>
          </>
        )}
      </TransformWrapper>
      <button
        type="button"
        className="lightbox__x"
        onClick={onClose}
        aria-label="Close"
        data-testid="lightbox-x"
      >
        &times;
      </button>
    </div>
  );
}
